import styled, { keyframes } from "styled-components";
import { TextField } from "@mui/material";
import { TextM } from "../../common/text";

export const MIN_Y = 10;
export const MAX_Y = 50;
export const BOTTOM_SHEET_HEIGHT = 60 - MIN_Y;

export const BottomSheetWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: 2;
`;

export const BottomSheetHalfBackground = styled.div`
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
`;

const bottomSheetMountAnimation = keyframes`
  0% {
  transform: translate3d(0, 150%, 0);
  }
  100% {
  transform: translate3d(0, 0%, 0);
  }
`;

const bottomSheetUnMountAnimation = keyframes`
  0% {
  transform: translate3d(0, 0%, 0);
  }
  100% {
  transform: translate3d(0, 150%, 0);
}
`;

export const BottomSheet = styled.div`
  display: flex;
  flex-direction: column;

  position: fixed;
  z-index: 3;
  top: 50%;

  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: #ffffff;
  height: ${BOTTOM_SHEET_HEIGHT}vh;

  animation: ${({ isMount }) =>
      isMount ? bottomSheetMountAnimation : bottomSheetUnMountAnimation}
    0.75s ease-out forwards;
`;

export const BottomSheetHeader = styled.div`
  height: 5vh;
  border-top-left-radius: 12px;
  border-bottom-right-radius: 12px;
  position: relative;
  padding-top: 12px;
  padding-bottom: 4px;
`;

export const BottomSheetHandle = styled.div`
  width: 40px;
  height: 40px;
  padding-left: 10px;
`;

export const BottomSheetContent = styled.div`
  width: 100vw;
  height: 45vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;

export const BottomSheetContentTextWrapper = styled.div`
  width: 100vw;
  height: 10vh;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
`;

export const BottomSheetContentInputWarpper = styled.div`
  width: 100vw;
  height: 25vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 30px;
  }
`;

export const BottomSheetInput = styled(TextField)`
  width: 80vw;
  height: 50px;
  // 크롬 아이디 자동완성시 기본 배경색 제거
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
  .MuiInputBase-input {
    font-size: 16px;
    font-family: "Bold";
    text-align: center;
  }
  label.Mui-focused {
    color: #f44b59;
  }
  .MuiInput-underline:after {
    border-bottom-color: #f44b59;
  }
  .MuiFormHelperText-root {
    color: #f44b59;
    text-align: center;
  }
  @media ${({ theme }) => theme.device.tablet} {
    width: 80%;
    height: 45px;
    .MuiInputBase-input {
      font-size: 25px;
      font-family: "Bold";
      text-align: center;
    }
    .MuiFormHelperText-root {
      font-size: 18px;
    }
  }
`;

export const BottomSheetContentButtonWrapper = styled.div`
  width: 100vw;
  height: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const BottomSheetContentButton = styled.div`
  width: 90%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ isValidInput }) =>
    isValidInput ? "#f44b59" : "#eaeaea"};
  border-radius: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    height: 80px;
    border-radius: 10px;
  }
`;

export const BottomSheetContentButtonText = styled(TextM)`
  color: ${({ isValidInput }) => (isValidInput ? "#ffffff" : "#9F9F9F")};
`;
